export class SezUsError extends Error {
  static get messages() {
    return 'This property can only be read.';
  }

  static set messages(value) {
    throw new Error(`The messages property cannot be written. ${value} was passed.`);
  }

  constructor(messages) {
    if (new.target === SezUsError) throw TypeError("New of abstract class SezUsError");

    super(messages.internal);

    this.messages = messages;

    Object.setPrototypeOf(this, SezUsError.prototype);
  }

  serialize() {
    throw new Error('You have to implement the method serialize!');
  }
}
